export default __webpack_public_path__ + "static/media/shopping-bag.0c48d274.svg";